import { PLANS, type PlanLimits, type PlanName } from '../plans';

export interface PlanState {
  plan: PlanName;
  limits: PlanLimits;
}

/**
 * Returns the current user's plan and associated limits.
 *
 * Subscriptions will be managed by Stripe in the future.
 * For now every user is on the free plan.
 */
export function usePlan(): PlanState {
  // TODO: fetch plan tier from Firestore / Stripe when billing is wired up.
  const plan: PlanName = 'free';
  return { plan, limits: PLANS[plan] };
}
